import React from "react";
import css from './selfFloor.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";
import GoodsType, {goodsTypeEnumMap} from "enum/GoodsType";
import MyRouterUtil from "utils/MyRouterUtil";
import {useHistory} from "react-router-dom";
import useFetchNav from "@/hooks/useFetchNav";

const Index = ({className, selfFloorStore}) => {

    const {data: nav} = useFetchNav()

    let {adv1 = {}, adv2 = {}, goodsList = []} = selfFloorStore;
    const history = useHistory()

    goodsList = goodsList.map(item => {
        const {pddGoodsSign, jdItemId, selfGoodsId} = item;

        let id;
        switch (item.goodsType) {
            case GoodsType.PDD:
                id = pddGoodsSign;
                break;
            case GoodsType.JD:
                id = jdItemId
                break;
            case GoodsType.SELF:
            default:
                id = selfGoodsId
                break;
        }
        return {
            ...item,
            id
        }
    })

    const onClickAdv1 = () => {
        window.open(adv1.link, "_blank")
    }

    const onClickAdv2 = () => {
        window.open(adv2.link, "_blank")
    }

    //to goodsInfo
    const toGoodsInfo = ({id, goodsType}) => {
        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id})
    }

    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={css.title}>
                    {nav?.selfRun}
                </div>

                <div className={css.floor1}>
                    <div className={css.adv1} onClick={onClickAdv1}>
                        <img src={adv1.file} alt=""/>
                    </div>
                    <div className={css.adv2} onClick={onClickAdv2}>
                        <img src={adv2.file} alt=""/>
                    </div>
                </div>
                <div className={css.floor2}>
                    <div className={css.floor2Left}>
                        <img src={require('./img/首页自营楼层商品列表左.png')} alt=""/>
                    </div>
                    <div className={css.floor2Right}>
                        <div className={css.goodsList}>
                            {
                                goodsList.map((item,index) => {
                                    const {id, mainPic, name, price, oldPrice, goodsType} = item;
                                    return (
                                        <div key={index} className={css.goods}
                                             onClick={() => {
                                                 toGoodsInfo({id, goodsType})
                                             }}>
                                            <div className={css.top}>
                                                <img src={mainPic} alt=""/>
                                            </div>
                                            <div className={css.bottom}>
                                                <div className={css.nameWrapper}>
                                                    <div className={css.name}>
                                                    <span className={classNames({
                                                        [css.self]: goodsType === GoodsType.SELF,
                                                        [css.pdd]: goodsType === GoodsType.PDD,
                                                        [css.jd]: goodsType === GoodsType.JD
                                                    })}>{goodsTypeEnumMap.get(goodsType)}</span>
                                                        {name}
                                                    </div>
                                                </div>
                                                <div className={css.priceWrapper}>
                                                    <div className={css.price}>
                                                        {`￥${price}`}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)